(function (root) {
  'use strict';

  function tokens(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .split(/[^a-z0-9]+/)
      .filter(Boolean);
  }

  function matches(query, title) {
    var titleTokens = tokens(title);
    return tokens(query).every(function (token) { return titleTokens.indexOf(token) !== -1; });
  }

  function apply() {
    var query = new URLSearchParams(root.location.search).get('q');
    var list = document.querySelector('#collection');
    if (!query || !list) return;
    var cards = Array.prototype.slice.call(list.querySelectorAll(':scope > .product-card'));
    var exactCards = cards.filter(function (card) {
      var title = card.querySelector('h3 a');
      return title && matches(query, title.textContent);
    });
    if (!exactCards.length) return;
    exactCards.reverse().forEach(function (card) { list.prepend(card); });
    list.setAttribute('data-cp-exact-ranked', 'true');
  }

  var api = { tokens: tokens, matches: matches, apply: apply };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.CoproomSearchExact = api;
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
    else apply();
  }
})(typeof window !== 'undefined' ? window : globalThis);
